import React from 'react';
import PropType from 'prop-types';

import Button from '@Components/Button';


export function getButtonInfo (isListView) {
  if (isListView) {
    return {
      icon: 'grid-tiles',
      label: 'Grid',
    };
  }

  return {
    icon: 'grid-list',
    label: 'List',
  };
}

export default function GridListViewButton (props) {
  const {
    isListView,
    togglerResultView,
    isSubstancesContext,
  } = props;

  if (!isSubstancesContext) {
    return null;
  }

  const { icon, label } = getButtonInfo(isListView);

  return (
    <Button
      id="toggleView"
      onClick={() => {
        togglerResultView();
      }}
      buttonConfig={{
        label,
        type: 'tertiary',
        size: 'sm',
        e2eName: 'toggle-view',
      }}
      iconConfig={{
        name: icon,
        size: 'sm',
      }}
    />
  );
}

GridListViewButton.propType = {
  isListView: PropType.bool.isRequired,
  togglerResultView: PropType.func.isRequired,
  isSubstancesContext: PropType.bool.isRequired,
};
